export const CLASS_NAME_OPEN = 'is-open';
